
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import { FormattedHTMLMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import './styles.css';
const BusinessPlanLink = ({
	to,
	icon,
	label,
	activeColorClass,
	disabledOpacity,
	done,
	download
}) =>
	<NavLink
		to={to}
		className={`business-plan-link ${activeColorClass} ${
			disabledOpacity ? 'business-plan-link-disabled-opacity' : ''
		}`}
	>
		<Icon className="icon business-plan-link-icon-disabled" icon={icon} />
		<Icon
			className="icon business-plan-link-icon-active"
			icon={`${icon}Active`}
		/>
		<FormattedHTMLMessage id={label} />
		{done && <Icon icon={'businessplancheck'} />}
		{download && <Icon icon={'businessplandownload'} />}
	</NavLink>
;

BusinessPlanLink.propTypes = {
	to: PropTypes.string.isRequired,
	icon: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	active: PropTypes.bool,
	disabledOpacity: PropTypes.bool,
	activeColorClass: PropTypes.string,
	done: PropTypes.bool,
	download: PropTypes.bool
};

export default BusinessPlanLink;
